import React, { Component } from "react";
import ReactRevealText from "react-reveal-text";
import TextLoop from "react-text-loop";

class Wrapper extends Component {
  constructor() {
    super();
    this.state = { show: false };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ show: true });
    }, 2000);
    console.log('I love you Megans');
  }

  render() {
    const bgStyles = {
      padding: "36px"
    };
    const textStyles = {
      color: "black",
      fontSize: "36px",
      lineHeight: "36px",
      fontFamily: "Merriweather",
      textAlign: "center",
      letterSpacing: "1em",
      paddingLeft: "1em" // to compensate for letter spacing
    };
    return (
      <div style={bgStyles}>
        <div style={textStyles}>
          <ReactRevealText
            show={this.state.show}
            text="WELCOME TO TRES WINES"
          />
        </div>
        <center>
          <img
            src="https://media.giphy.com/media/dELGKWcfByKg8/giphy.gif"
            style={{
              paddingTop: 25
            }}
            alt="this is a placeholder"
          />
        </center>
        <h1
          style={{
            fontSize: "24px",
            textAlign: "center",
            color: "black",
            fontFamily: "Merriweather",
          }}
        >
          Because{" "}
          <TextLoop speed={2500}>
            <span>it's a lifestyle brand.</span>
            <span>it's brings our friends together.</span>
            <span>it's important.</span>
            <span>it's you.</span>
          </TextLoop>
        </h1>
        <p
          style={{
            fontSize: "12px",
            position: "absolute",
            textAlign: "center",
            color: "black",
            fontFamily: "Merriweather",
            bottom: 0
          }}
        >
          made with{" "}
          <span role="img" aria-label="two hearts">
            💜💛
          </span>{" "}
          by Crispy in SEA
        </p>
      </div>
    );
  }
}

export default Wrapper;



// WEBPACK FOOTER //
// ./src/App.js